import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Spin } from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
  req_config_gsm_gate_status,
  req_edit_gsm_gate_status,
} from "../../api";
class GateControlConfig extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    item: {
      Uid: "",
      SchoolGateLocation: "",
      GateStatus: "",
      ChangeStatusUserCode: "",
    },
    items: [],
    userLevel: "NORMAL",
    isDisabled: false,
  };

  UNSAFE_componentWillMount() {
    this.api_init_data();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_init_data = async () => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_config_gsm_gate_status(userCode, userLevel, token);

    if (result.total > 0) {
      const item = result.data[0];
      this.setState({ item });
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    console.log(item);
    const result = await req_edit_gsm_gate_status(item, token);
    if (result.status === "success") {
      this.api_init_data();
    }
  };

  handle_status = () => {
    this.disableButton();
    const { item } = this.state;
    const { userCode } = this.props.user;
    const obj = {
      Uid: item.Uid,
      SchoolGateLocation: item.SchoolGateLocation,
      ChangeStatusUserCode: userCode,
      GateStatus: item.GateStatus === "OFF" ? "ON" : "OFF",
      condition: "BASE",
    };

    this.api_modify_item(obj);
  };

  disableButton = () => {
    this.setState({ isDisabled: true }, () =>
      setTimeout(() => {
        this.setState({ isDisabled: false });
      }, 3000)
    );
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { isDisabled } = this.state;
    const { SchoolGateLocation, GateStatus } = this.state.item;

    return (
      <Card>
        <div className="text-center">
          <h1 style={{ fontWeight: "bold", fontSize: "2em" }}>
            {SchoolGateLocation}
          </h1>
          <div style={{ fontWeight: "bold", fontSize: "1.2em" }}>門禁登記</div>
          <div>
            <p></p>
            {GateStatus === "OFF" ? (
              <button
                className={"btn btn-success"}
                onClick={this.handle_status}
                // disabled={isDisabled}
                disabled={true}
              >
                目前
                <i
                  className="fa fa-times"
                  style={{ marginRight: "4px", marginLeft: "4px" }}
                ></i>
                關閉
              </button>
            ) : (
              <button
                className={"btn btn-warning"}
                onClick={this.handle_status}
                // disabled={isDisabled}
                disabled={true}
              >
                目前
                <i
                  className="fa fa-id-badge"
                  style={{ marginRight: "4px", marginLeft: "4px" }}
                ></i>
                開啟
              </button>
            )}
          </div>
          {isDisabled === true ? (
            <div style={{ marginTop: "5px" }}>
              <Spin /> 轉換中...
            </div>
          ) : (
            <span></span>
          )}
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(GateControlConfig);
